export const SENTRY_RELEASE: string | undefined = '5bc49322720e5e0fe2d2447dc11c47e2c1478dd5';
